
import React, { useState } from "react";
import { CardMedia } from "@mui/material";

function ResponsiveCardMedia({
  imageSrc,
  fallbackSrc,
  alt = "Entity Visual",
  width = 300,
  registerHeight,
  forcedHeight,
}) {
  const [src, setSrc] = useState(imageSrc);

  const handleImageLoad = (e) => {
    const { naturalWidth, naturalHeight } = e.target;

    if (naturalWidth && naturalHeight && typeof registerHeight === "function") {
      const aspectRatio = naturalWidth / naturalHeight;
      const height = width / aspectRatio;
      registerHeight(Math.round(height));
    }
  };

  return (
    <CardMedia
      component="img"
      image={src}
      alt={alt}
      onLoad={handleImageLoad}
      onError={() => setSrc(fallbackSrc)}
      sx={{
        height: forcedHeight ? `${forcedHeight}px` : "auto",
        objectFit: "cover",
        m:"5px"
      }}
    />
  );
}

export default ResponsiveCardMedia;
